import {AttachmentUrlService} from "../../../../services/common/attachment-url.service";
import {TranslationService} from "../../../../services/wrapper/translation.service";
import {BannerLayoutComponent} from "../../banner-layout.component";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {NotificationService} from "../../../../services/common/notification.service";
import {Utilities} from "../../../../utils/utilities";
import {
    BannerImageEditComponent
} from "../../../../pages/translation/banner/modal/banner-image-edit/banner-image-edit.component";
import {EventEmitter} from "@angular/core";
import {MyStorageService} from "../../../../services/common/my-storage.service";
import {Constants} from "../../../../utils/constants";
import {BannerContentModel} from "../../banner-content-layout/banner-content.model";


export class ImgCommonLayoutComponent extends BannerLayoutComponent<any[]> {
    urls: any[] = [];
    title: string = 'banner.defaultImg';
    emit: EventEmitter<any>;


    constructor(protected attachmentUrlService: AttachmentUrlService, translationService: TranslationService, modalService: BsModalService, notificationService: NotificationService, myStorageService:MyStorageService) {
        super(translationService, modalService, notificationService, myStorageService);
    }

    protected initImages() {
        this.data.forEach(imgKey => {
            const imgOne = this.attachmentUrlService.getScaleWidthImageUrlBySlug(this.translate(this.slug + "." + imgKey), 800);
            this.urls.push(imgOne);
        })
    }

    editImg(index: number) {
        const slug = this.translate(this.slug + "." + this.data[index]);
        const config = Utilities.createModalConfig({
            imgSlug: slug
        });
        const bsRef: BsModalRef = this.modalService.show(BannerImageEditComponent, config);
        bsRef.content.onCloseWithResponse.subscribe(imgSlug => {
            this.updateImage(imgSlug, index);
        })
    }

    private updateImage(slug: any, index: number) {
        const useTo = this.myStorageService.getFromCookiesWithParse(Constants.USE_TO_ALL_RESTAURANTS, false);
        if (useTo) {
            const restaurants = this.myStorageService.getFromCookiesWithParse(Constants.USER_REST_KEY, []);
            restaurants.forEach(restaurant => {
                this.updateImageTranslation(slug, this.getTranslation(restaurant.historySlug + "." + this.data[index]), index);
            });
        } else {
            this.updateImageTranslation(slug, this.getTranslation(this.slug + "." + this.data[index]), index);
        }
    }

    private updateImageTranslation(slug: any, translation, index) {
        Object.values<any>(translation.localizations).forEach(localization => {
            localization.value = slug;
        });
        this.translationService.update(translation).subscribe(result => {
            this.urls[index] = this.attachmentUrlService.getScaleWidthImageUrlBySlug(slug, 800);
            this.emit.emit();
            this.notificationService.showSuccess("general.success");
        })
    }

}
